import React, { useRef } from 'react';
import { Tour } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

const AdminTour = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { markTutorialStatus } = useAuth();
  const finishedRef = useRef(false);

  const handleFinish = async () => {
    finishedRef.current = true;
    await markTutorialStatus('COMPLETED');
    onClose(true);
  };

  // antd Tour fires onClose before onFinish when the Finish button is clicked.
  // Deferring by one macrotask gives handleFinish time to set finishedRef first.
  const handleClose = () => {
    setTimeout(async () => {
      if (!finishedRef.current) {
        await markTutorialStatus('SKIPPED');
        onClose(false);
      }
    }, 0);
  };

  const steps = [
    {
      title: t('tutorial.step1.title'),
      description: t('tutorial.step1.description'),
      target: null,
    },
    {
      title: t('tutorial.step2.title'),
      description: t('tutorial.step2.description'),
      target: () => document.querySelector('[data-testid="nav-dashboard"]'),
    },
    {
      title: t('tutorial.step3.title'),
      description: t('tutorial.step3.description'),
      target: () => document.querySelector('[data-testid="nav-employees"]'),
    },
    {
      title: t('tutorial.step4.title'),
      description: t('tutorial.step4.description'),
      target: () => document.querySelector('[data-testid="nav-departments"]'),
    },
    {
      title: t('tutorial.step5.title'),
      description: t('tutorial.step5.description'),
      target: () => document.querySelector('[data-testid="nav-leave"]'),
    },
    {
      title: t('tutorial.step6.title'),
      description: t('tutorial.step6.description'),
      target: () => document.querySelector('[data-testid="nav-calendar"]'),
    },
    {
      title: t('tutorial.step7.title'),
      description: t('tutorial.step7.description'),
      target: () => document.querySelector('[data-testid="language-switcher"]'),
    },
    {
      title: t('tutorial.step8.title'),
      description: t('tutorial.step8.description'),
      target: () => document.querySelector('[data-testid="user-menu"]'),
    },
  ];

  return (
    <Tour
      open={open}
      onClose={handleClose}
      onFinish={handleFinish}
      steps={steps}
      data-testid="admin-tour"
    />
  );
};

export default AdminTour;
